import { useNavigate } from 'react-router-dom';
import Template from '../../component/Template';
import useAuth from '../../component/useAuth';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";

import { Link } from 'react-router-dom';

import '../../Assets/css/vendors/datatables.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';

import logo from "../../Assets/images/gif/danger.gif";


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { useDownloadExcel } from 'react-export-table-to-excel';



export default function Course() {
    const navigate = useNavigate();
    const isAuth = useAuth();
    if (isAuth === false) {
        navigate("/admin/")
    }



    const [courses, setCoursesData] = useState([]);
    const [isDelete, setDelete] = useState(false);
    const [deleteid, setDeleteid] = useState(false);
    const [istost, settost] = useState(false);
    const tableRef = useRef(null); const [retryAttempt, setRetryAttempt] = useState(0);

    const [facultychange, setfacultychange] = useState(false); //05/03/2024
    const [faculty, setFacultyData] = useState([]);
    const [discipline, setDiscipline] = useState([]);

    const [disciplinechange, setdisciplinechange] = useState(false); //05/03/2024
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort05/03/2024

    const [semester, setSemester] = useState([]); //23/3/2024-filter
    const [semesterchange, setSemesterchange] = useState(false); //23/3/2024-filter
    const [coursecomponentstypes, setCoursecomponenttypeData] = useState([]);
    const [coursecompchange, setCourseCompchange] = useState(false); //23/3/2024-filter

    const [schemeId, setSchemeId] = useState(null);


    const [totalcourse, setTotalCourse] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);

    const [isAccess, setAccess] = useState({
        addcourse: false,
        viewcourse: false,
        updatecourse: false,
        deletecourse: false
    });

    const [ismobile, setIsmobile] = useState(false);
    const togglemenu = () => {
        setIsmobile(!ismobile);
    };



    //role validation
    useEffect(() => {
        const access = async () => {
            const { http } = Api();
            const id = localStorage.getItem("id");
            try {
                const response4 = await http.get('/Admin/getfaculty');
                setFacultyData(response4.data.data);
                const response1 = await http.get(`/Admin/getdiscipline`);
                setDiscipline(response1.data.data);
                const response5 = await http.get('/Admin/getsemester');
                setSemester(response5.data);
                const response = await http.get('/Admin/get-all-user-permissions', { params: { user_id: id } });
                const permissions = response.data.map(permission => permission.name);

                const hasAddPermission = permissions.includes("add-course");
                const hasViewPermission = permissions.includes("view-course");
                const hasUpdatePermission = permissions.includes("update-course");
                const hasDeletePermission = permissions.includes("delete-course");

                setAccess({
                    addcourse: hasAddPermission,
                    viewcourse: hasViewPermission,
                    updatecourse: hasUpdatePermission,
                    deletecourse: hasDeletePermission
                });
            } catch (error) {
                console.error("Error fetching user roles:", error);
            }
        };
        access();
    }, []);

    // Function to handle sorting-sort05/03/2024
    const handleSort = (column) => {
        const newSortBy = {
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        };
        setSortBy(newSortBy);
    };

    // Sort userlog based on sortBy state-sort05/03/2024
    const sortedCourse = Array.isArray(courses)
  ? [...courses].sort((a, b) => {
        const valA = a?.[sortBy.column] ?? "";
        const valB = b?.[sortBy.column] ?? "";

        if (sortBy.direction === "asc") {
            return valA > valB ? 1 : -1;
        } else {
            return valA < valB ? 1 : -1;
        }
    })
  : [];


    // Function to render sort icon-sort05/03/2024
    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
    };


    const [showFilter, setShowFilter] = useState(false); // State to control filter section visibility
    const toggleFilter = () => {
        setShowFilter(!showFilter); // Toggle filter section visibility
    };

    const closeFilter = () => {
        setShowFilter(false); // Close filter section
    };


    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'Course Database',
        sheet: 'Course',
    });


    //23/3/2024-filter
    useEffect(() => {
        fetchData();
    }, [currentPage, facultychange, retryAttempt, disciplinechange, semesterchange, coursecompchange,searchQuery]);



    const fetchData = async () => {
        try {
            const { http } = Api();
            settost(sessionStorage.getItem("message"));


            const facultyNameParam = facultychange == false ? undefined : facultychange;
            const disciplineNameParam = disciplinechange == false ? undefined : disciplinechange;
            const sem = semesterchange == false ? undefined : semesterchange;
            const coursechange = coursecompchange == false ? undefined : coursecompchange;
            const searchParam = searchQuery === '' ? undefined : searchQuery;


            console.log("sem=", semesterchange)

            if (semesterchange) {


                //const response6 = await http.get(`/Admin/getcourseComponentStructure/${semesterchange}?semester_id=${semesterchange}&scheme_id=${schemeIdParam}`);
                //console.log("comp=", response6)
                //setCoursecomponenttypeData(response6.data);

            }
            const response = await http.get(`/Admin/getcourse?page=${currentPage}`, {
                params: {
                    limit: '50',
                    faculty_id: facultyNameParam,
                    discipline_id: disciplineNameParam,
                    semester_id: sem,
                    search: searchParam,
                    status: "",
                    id: "",
                    course_curriculum_structure_component_id: coursechange
                }
            });


            const CourseListData = response.data;

            setCoursesData(CourseListData.data);
            setTotalPages(Math.ceil(response.data.total / 50));
            setTotalCourse(response.data.total);
            console.log("course data=", response);

        } catch (error) {
            // Retry logic with exponential backoff
            const delay = Math.pow(2, retryAttempt) * 1000; // Exponential backoff formula
            setTimeout(() => {
                setRetryAttempt(retryAttempt + 1);
            }, delay);
            console.error('Error fetching Course data:', error);
        }
    };


    useEffect(() => {
        if (istost) {
            toast.success(istost);
            sessionStorage.removeItem("message");
            settost(false);
        }
    }, [istost]);

    const handleDeleteSuccess = async () => {
        const { http } = Api();
        try {
            const response = await http.delete(`/Admin/deletecourse/${deleteid}`);
            console.log(response);
            if (response.data.status_code === "MSG3") {
                setDelete(false);
                sessionStorage.setItem("message", "Course deleted successfully!")
                window.location.reload();
            }
        } catch (error) {
            toast.error("Something went wrong"); // Show error toast
            console.error('Error deleting Course:', error);
        }
    }

    const encodeID = id => {
        return btoa(id);
    };

    const encodeSemID = semid => {
        return btoa(semid);
    };
    const handleDelete = (id) => {
        setDeleteid(id);
        setDelete(true);
    }

    const handleCancel = () => {
        setDelete(false);
    }

    const handleExportDropdownToggle = (event) => {
        const selectedValue = event.target.value;
        if (selectedValue === "1") {
            // Handle PDF conversion
        } else if (selectedValue === "2") {
            // Handle CSV conversion
        } else if (selectedValue === "3") {
            onDownload();
        }
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Function to handle changes in the search input field
    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };


    useEffect(() => {
    if (!Array.isArray(courses) || courses.length === 0) {
        setfilteredAndSortedData([]); // no data
        return;
    }

    const filteredAndSortedData = courses
        .filter(course =>
            (course?.course_name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (course?.course_code || '').toLowerCase().includes(searchQuery.toLowerCase())
        )
        .sort((a, b) => {
            if (sortBy.direction === 'asc') {
                return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
            } else {
                return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
            }
        });

    setfilteredAndSortedData(filteredAndSortedData);
}, [sortBy, courses, searchQuery]);


    //for kebabmenu 12/3/2024
    // for kebabmenu 12/3/2024

    const [openKebabCourseId, setOpenKebabCourseId] = useState(null);

    // Function to toggle the kebab menu for a specific row
    const toggleKebabMenu = (courseId) => {
        // Toggle the open state for the specified course ID
        setOpenKebabCourseId(prevCourseId => (prevCourseId === courseId ? null : courseId));
    };


    // Close kebab menu when clicking anywhere on the screen -- 20/3/2024
    useEffect(() => {
        function handleClickOutside(event) {
            // Check if any kebab menu is open
            const isOpen = openKebabCourseId !== null;

            // Check if click is outside kebab menu and any kebab menu is open
            if (isOpen && !event.target.closest('.kebab-menu')) {
                // Close the open kebab menu
                setOpenKebabCourseId(null);
            }
        }

        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        };
    }, [openKebabCourseId]);

    return (
        <>
            <ToastContainer />
            <div className={`modal fade show ${isDelete ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="modal-toggle-wrapper">
                                <ul className="modal-img">
                                    <li> <img src={logo} /></li>
                                </ul>
                                <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                                <div className="d-flex justify-content-center mt-3">
                                    <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Template>
                {/* Container-fluid starts*/}

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">

                            <div className="card">
                                <div className="card-header card-heading">
                                    <div className="py-3 d-flex justify-content-between align-items-center">
                                        <h5 className="lbl1">Course</h5>
                                        <div className="d-flex ml-auto">
                                            {/* Responsive Dropdown or Hamburger Menu */}
                                            <div className="dropdown d-lg-none">
                                                <button
                                                    className="btn btn-light dropdown-toggle"
                                                    type="button"
                                                    id="mobileActionsDropdown"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded={ismobile}
                                                    onClick={togglemenu}
                                                >
                                                    <i className="fas fa-bars"></i>
                                                </button>
                                                <div
                                                    className={`dropdown-menu dropdown-menu-right ${ismobile ? 'show' : ''}`}
                                                    aria-labelledby="mobileActionsDropdown"
                                                    style={{
                                                        margin: '10px 20px 20px -60px',
                                                        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                                                        borderRadius: '0.5rem',
                                                        overflow: 'hidden',
                                                        color: 'black',
                                                    }}
                                                >
                                                    <a
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                            toggleFilter();
                                                            togglemenu();
                                                        }}
                                                    >
                                                        <i
                                                            className={`bi ${showFilter ? 'bi-x-circle-fill' : 'bi-funnel-fill'} show`}
                                                            aria-hidden="true"
                                                            style={{ cursor: "pointer", color: 'black' }}
                                                        > Filter</i>
                                                    </a>
                                                    <div className="dropdown-divider my-0"></div>
                                                    <div className="dropdown-item py-3">
                                                        <select
                                                            className="form-select btn-border"
                                                            id="inputGroupSelect01"
                                                            onChange={handleExportDropdownToggle}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <option selected="">Export As</option>
                                                            <option value="1">Pdf</option>
                                                            <option value="2">Csv</option>
                                                            <option value="3">Excel</option>
                                                        </select>
                                                    </div>
                                                    <div className="dropdown-divider my-0"></div>
                                                    {isAccess.addcourse && (
                                                        <Link className="dropdown-item" to="/admin/courseadd">
                                                            <i
                                                                className="bi bi-plus-circle-fill show"
                                                                style={{ cursor: "pointer", color: 'black' }}
                                                            > Add New</i>
                                                        </Link>
                                                    )}
                                                </div>
                                            </div>


                                            {/* Desktop View */}
                                            <div className="d-none d-lg-flex">
                                                <div className="light-box">
                                                    <a style={{ marginLeft: "10px" }} onClick={toggleFilter} className="btn btn-light">
                                                        <i className={`fa fa-filter ${showFilter ? 'icon-close' : 'filter-icon'} show`} aria-hidden="true"></i>
                                                    </a>
                                                    &nbsp;&nbsp;
                                                </div>
                                                <div className="form-group">
                                                    <select className="form-select btn-border" id="inputGroupSelect01" onChange={handleExportDropdownToggle} style={{ cursor: "pointer" }}>
                                                        <option selected="">Export As</option>
                                                        <option value="1">Pdf</option>
                                                        <option value="2">Csv</option>
                                                        <option value="3">Excel</option>
                                                    </select>
                                                </div>
                                                &nbsp;&nbsp;
                                                {isAccess.addcourse && (
                                                    <Link className="btn btn-primary form-group" to="/admin/courseadd">
                                                        <span className="icon">&#43;</span>
                                                        <div className="txtsh"> Add New</div>
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`collapse ${showFilter ? 'show' : ''}`} id="collapseProduct" style={{ margin: "20px 20px 20px 20px" }}>
                                    <div className="card card-body list-product-body">
                                        {/*23/3/2024-filter*/}
                                        <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-2 g-3  justify-content-end">
                                            {/* <div className="col">
                                                <select className="form-select scrollable-bar-select" aria-label="Default select example" defaultValue={false} onChange={(e) => setfacultychange(e.target.value)}>
                                                    <option value={0}>Select Faculty</option>
                                                    {faculty.map(facultys => (
                                                        <option value={facultys.id} key={facultys.id}>{facultys.faculty_name}</option>
                                                    ))}
                                                </select>
                                            </div> */}
                                            <div className="col">
                                                <select className="form-select scrollable-bar-select" aria-label="Default select example" defaultValue={false}
                                                    //onChange={(e) => setdisciplinechange(e.target.value)}

                                                    onChange={(e) => {
                                                        const selectedId = parseInt(e.target.value);
                                                        setdisciplinechange(selectedId);
                                                        const selectedDiscipline = discipline.find(d => d.id === selectedId);
                                                        if (selectedDiscipline) {
                                                            setSchemeId(selectedDiscipline.scheme_id);
                                                        }
                                                    }}>
                                                    <option value={0}>Select Discipline</option>
                                                    {discipline.map(disciplines => (
                                                        <option value={disciplines.id} key={disciplines.id}>{disciplines.discipline_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col">
                                                <select className="form-select scrollable-bar-select" aria-label="Default select example" defaultValue={false} onChange={(e) => setSemesterchange(e.target.value)}>
                                                    <option value={0}>Select Semester</option>
                                                    {semester.map(sem => (
                                                        <option value={sem.semester_no} key={sem.semester_no}>{sem.semester_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            {/* <div className="col">
                                                <select className="form-select scrollable-bar-select" aria-label="Default select example" defaultValue={false} onChange={(e) => setCourseCompchange(e.target.value)}>
                                                    <option value={0}>Select Course </option>
                                                    {coursecomponentstypes.length > 0 && (
                                                        coursecomponentstypes.map(coursecomponentstype => (
                                                            <option key={coursecomponentstype.course_curriculum_structure_component_id} value={coursecomponentstype.course_curriculum_structure_component_id}>{coursecomponentstype.course_discipline_component}</option>
                                                        ))
                                                    )}
                                                </select>
                                            </div> */}
                                            <div className="col">
                                                <button className="btn btn-primary" onClick={() => window.location.reload()} style={{ width: "100%" }}>Clear All</button>
                                            </div>
                                            {/* <div className="col">
                                                <input className="form-control input-air-primary" type="text" placeholder="Course Title" />
                                            </div> */}
                                            {/*end of 23/3/2024-filter*/}
                                        </div>
                                    </div>
                                </div>



                                {isAccess.viewcourse ? (
                                    <div className="card-body">
                                        <div className="card-body pdg1">
                                            <div className="table-responsive">
                                                <div className='row'>
                                                    <div className='col-md-6 wdt' >
                                                        <p>
                                                            Showing {(currentPage - 1) * 50 + 1}{''}-
                                                            {Math.min((currentPage - 1) * 50 + 50, totalcourse)} of {totalcourse} entries
                                                        </p>
                                                    </div>
                                                    <div className='col-md-6 wdt' align='right'>
                                                        <input
                                                            type="text"
                                                            value={searchQuery}
                                                            onChange={handleSearchInputChange}
                                                            placeholder="Search ... "
                                                            className='form-control'
                                                            style={{ width: '' }}
                                                        /></div></div>
                                                <table className="display dataTable table-striped table-bordered" ref={tableRef}>
                                                    <thead>
                                                        <tr className="bg-primary">
                                                            {/*-sort05/03/2024-start*/}

                                                            <th onClick={() => handleSort('created_at')}>
                                                                Sl No &nbsp;

                                                            </th>
                                                            <th onClick={() => handleSort('course_code')}>
                                                                Course Code&nbsp;
                                                                {renderSortIcon('course_code')}
                                                            </th>
                                                            <th onClick={() => handleSort('course_name')}>
                                                                Course Title&nbsp;
                                                                {renderSortIcon('course_name')}
                                                            </th>
                                                            <th onClick={() => handleSort('faculty_name')}>
                                                                Faculty Name&nbsp;
                                                                {renderSortIcon('faculty_name')}
                                                            </th>
                                                            <th onClick={() => handleSort('discipline_name')}>
                                                                Discipline Name&nbsp;
                                                                {renderSortIcon('discipline_name')}
                                                            </th>
                                                            <th onClick={() => handleSort('semester_name')}>
                                                                Semester Name&nbsp;
                                                                {renderSortIcon('semester_name')}
                                                            </th>
                                                            {/*<th onClick={() => handleSort('remarks')}>
                                    Remarks&nbsp;
                                    {renderSortIcon('remarks')}
        </th>*/}
                                                            <th onClick={() => handleSort('status')}>
                                                                Status&nbsp;
                                                                {renderSortIcon('status')}
                                                            </th>

                                                            <th>Action</th>


                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredAndSortedData.length > 0 ? (
                                                            filteredAndSortedData.map((course, index) => {
                                                                if (course.status !== 'deleted') {
                                                                    // Incrementing serial number for each non-deleted course
                                                                    const serialNumber = index + 1 + (currentPage - 1) * 50;
                                                                    return (
                                                                        <tr key={course.course_code}>
                                                                            <td>{serialNumber}</td>
                                                                            <td>{course.course_code} <br />
                                                                                {course.signature_course == 1 && (
                                                                                    <span
                                                                                        className="badge bg-success text-white"
                                                                                        style={{
                                                                                            fontSize: '11px',
                                                                                            fontWeight: '600',
                                                                                            padding: '4px 8px',
                                                                                            borderRadius: '12px',
                                                                                        }}
                                                                                    >
                                                                                        Signature Course
                                                                                    </span>
                                                                                )}



                                                                            </td>
                                                                            <td>
                                                                                {course.course_curriculum_structure_component_id == 1 || course.course_curriculum_structure_component_id == 12 ? (
                                                                                    <>
                                                                                        <Link to={`/admin/coursedisciplineAECmappingaec/${encodeURIComponent(course.course_name)}`}
                                                                                            title="AEC Mapping"
                                                                                            className="elecft1"
                                                                                        >
                                                                                            {course.course_name}
                                                                                        </Link>
                                                                                    </>
                                                                                ) : (
                                                                                    course.course_name

                                                                                )}
                                                                            </td>
                                                                            <td>{course.faculty_name}</td>
                                                                            <td>{course.discipline_name}</td>
                                                                            <td>{course.semester_name}</td>
                                                                            {/*<td>{course.remarks === 'Null' ? '' : course.remarks}</td>*/}
                                                                            <td>{course.status}</td>

                                                                            <td>
                                                                                <div className="kebab-menu">
                                                                                    <button className="kebab-menu-button" onClick={() => toggleKebabMenu(course.id)}>
                                                                                        &#8942;
                                                                                    </button>
                                                                                    <ul className="action">
                                                                                        {openKebabCourseId === course.id && (
                                                                                            <div className="kebab-menu-items kebab-ht">
                                                                                                {isAccess.updatecourse && course.verification_status != 'verified' && (
                                                                                                    <li className="edit">
                                                                                                        <Link to={`/admin/courseedit/${encodeID(course.id)}/${encodeSemID(course.semester_id)}`} title="Edit">
                                                                                                            <i className="icon-pencil-alt"></i>&nbsp;Edit

                                                                                                        </Link>
                                                                                                    </li>
                                                                                                )}
                                                                                                {isAccess.deletecourse && course.verification_status != 'verified' && (
                                                                                                    <li className="delete">
                                                                                                        <Link to="#" onClick={() => handleDelete(course.id)} title="Delete">
                                                                                                            <i className="icon-trash"></i>&nbsp;Delete
                                                                                                        </Link>
                                                                                                    </li>
                                                                                                )}
                                                                                                <li className="view">
                                                                                                    <Link to={`/admin/courseview/${encodeID(course.id)}`} title="View" target="_blank">
                                                                                                        <span className="icon-eye" style={{ cursor: "pointer" }} />&nbsp;View
                                                                                                    </Link>
                                                                                                </li>
                                                                                                {(course.course_curriculum_structure_component_id === 1 || course.course_curriculum_structure_component_id === 12) && (
                                                                                                    <li className="viewpage">
                                                                                                        <Link to="/admin/coursedisciplineAECmapping/" title="AEC Course Mapping">
                                                                                                            <i className="icon-pencil icon-lt-aln"></i>&nbsp;AEC Course &nbsp;Mapping
                                                                                                        </Link>
                                                                                                    </li>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </ul>
                                                                                </div>
                                                                            </td>

                                                                        </tr>
                                                                    );
                                                                } else {
                                                                    return null; // Skip rendering for deleted data
                                                                }
                                                            })

                                                        ) : (

                                                            <tr><td colspan="8" className="txt-aln">No Data Available</td></tr>

                                                        )}

                                                    </tbody>
                                                </table>
                                            </div>
                                            {totalPages > 1 && (
                                                <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                    <ul className="pagination justify-content-center">
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                                        </li>
                                                        <li className={`page-item`}>
                                                            <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                        </li>
                                                        {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                        {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                            <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                            </li>
                                                        ))}
                                                        {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                                        <li className={`page-item`}>
                                                            <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                        </li>

                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card-body">
                                        <div className="card-body pdg1">
                                            <div className="table-responsive">
                                                YOU DONT HAVE ACCESS TO VIEW THIS
                                            </div>
                                        </div>
                                    </div>

                                )}

                            </div>
                        </div>
                    </div>
                </div>



            </Template>
        </>




    );
}
